<template>
	<v-layout row wrap class="mb-5">
		<v-flex xs12 sm6 class="text-xs-center">
			<p class="add-event-step-header mb-4 text-xs-center">How many guests can be hosted here?</p>
			<p class="text-xs-center ml-4 mr-4 mb-1 mt-1 add-event-step-secondary-header">
				Number of places available (space capacity):
			</p>
			<p class="add-event-step-sub-header text-xs-center mb-4">*WRKPRTY Requires a minimum of 5 for all events.</p>
			<!-- <v-text-field class="ma-0" :error="!validSeats" :rules="[rules.seats]" v-model="seats" type="number"></v-text-field> -->
			<el-input-number :min="5" v-model="seats"></el-input-number>
		</v-flex>
		<v-flex xs12 md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card class="add-event-tip-box">
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="add-event-tip-content">Please note, except under rare exceptions, WRKPRTY coworking events are required to have AT LEAST five (5) attendees (and a MAXIMUM of 20) to ensure a high quality experience for all.</p>
					<p class="add-event-tip-content">For other types of events (e.g. Workshops, Networking events, etc.) there is no maximum attendee limit.</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-tip-content">Please note, except under rare exceptions, WRKPRTY coworking events are required to have AT LEAST five (5) attendees (and a MAXIMUM of 20) to ensure a high quality experience for all.</p>
					<p class="add-event-tip-content">For other types of events (e.g. Workshops, Networking events, etc.) there is no maximum attendee limit.</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	beforeRouteLeave(to, from, next) {
		this.setAddLocationValidStep(from.path)
		this.removeAddLocationInvalidStep(from.path)
		next()
	},
	methods: {
		...mapActions([
			'setAddLocationProp',
			'setAddLocationValidStep',
			'removeAddLocationValidStep',
			'setAddLocationInvalidStep',
			'removeAddLocationInvalidStep'
		])
	},
	computed: {
		...mapGetters(['getAddLocationProp']),
		seats: {
			get() {
				return this.getAddLocationProp('seats')
			},
			set(val) {
				this.setAddLocationProp({
					prop: 'seats',
					value: val
				})
			}
		},
		infoDialog: {
			get() {
				return this.getAddLocationProp('infoDialog')
			},
			set(val) {
				this.setAddLocationProp({ prop: 'infoDialog', value: val })
			}
		}
	}
}
</script>

<style>
</style>
